import { JBaseApi } from '../base';
import { OF } from '../../util/network';
import { ExtraBotConfig, jUserLittle, ListQueryParameters, PagingResults } from '../../types';

export type LinkConfigurationParams = {
    uriConfiguration: string;
    uriUser: string;
};

export class JExtraBotApi extends JBaseApi {
    public createBot(uri: string, signal?: AbortSignal) {
        return this.network.postCSRF<jUserLittle>(
            {
                o: 'extraBot',
                f: 'create',
                uri,
            } as OF,
            signal,
        );
    }

    public updateBot(uriConfiguration: string, signal?: AbortSignal) {
        return this.network.postCSRF<jUserLittle>(
            {
                o: 'extraBot',
                f: 'update',
                uriConfiguration,
            } as OF,
            signal,
        );
    }

    public generatePrompt(signal?: AbortSignal) {
        return this.network.post<string>(
            {
                o: 'extraBot',
                f: 'generatePrompt',
            } as OF,
            signal,
        );
    }

    public list(type: 'all' | 'mines', params: ListQueryParameters, signal?: AbortSignal) {
        const f = 'all' === type ? 'extraBotAll' : 'extraBotMines';

        return this.network.post<PagingResults<ExtraBotConfig>>(
            {
                o: 'objectList',
                f,
                ...params,
            } as OF,
            signal,
        );
    }
}
